import React from 'react';
import {Platform, TouchableOpacity, View} from 'react-native';
import {useSelector} from 'react-redux';
import {BodyText} from 'src/Modules/CommonView';
import {joinHunt} from 'src/Utils/huntFunctions';

import moment from 'moment';
import {useUserId, useUserInfo} from '../../Hooks/reduxHooks';

const ContinueHuntCard = ({warning = false, containerStyle = {}}) => {
  var showPreviousHuntCard = false;

  const currentHuntInfo = useUserInfo('currentHuntInfo');

  const userId = useUserId();

  const eventId = useSelector((state) => state.event?.eventId);

  // Alert.alert('')

  // last date a user joined a event
  const dateEventLastJoined = useSelector(
    (state) =>
      state.user?.info?.currentHuntInfo?.dateEventLastJoined ||
      state.user?.info?.currentHuntInfo?.dateEventCreated,
  );

  if (dateEventLastJoined && userId) {
    var a = moment();
    var b = moment(dateEventLastJoined);
    const diffHours = a?.diff?.(b, 'hours'); // =1
    console.log({diffHours});
    if (dateEventLastJoined && diffHours < 24 * 5) {
      console.log('ContinueHuntCard', {diffHours});
      showPreviousHuntCard = true;
    }
  }
  const handleJoinHuntPress = async (groupId) => {
    joinHunt(groupId, userId, 'Rejoining Hunt');
  };

  if (!showPreviousHuntCard) {
    console.log('not showing continue hunt card', {currentHuntInfo});
    return <View></View>;
  }

  console.log('showing continue hunt card', {currentHuntInfo, eventId});

  if (Platform.OS == 'web' && eventId && eventId != currentHuntInfo?.eventId) {
    return;
  }
  return (
    <View style={containerStyle}>
      <TouchableOpacity
        activeOpacity={0.8}
        onPress={() => handleJoinHuntPress(currentHuntInfo?.groupId, false)}
        style={{
          ...global?.style.fillAbsolute,
          backgroundColor: warning ? 'red' : global?.color?.gray3,
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <View
          style={{
            justifyContent: 'center',
            alignItems: 'center',
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            top: 0,
            paddingVertical: 5,
            paddingHorizontal: 5,
          }}>
          {!warning && (
            <View
              testID={'continueHunt'}
              style={{
                borderBottomWidth: 2,
                borderBottomColor: global?.color?.white,
                paddingBottom: 5,
                marginTop: 10,
              }}>
              <BodyText
                textStyle={{
                  color: global?.color?.white,
                  fontWeight: '700',
                  marginTop: 0,
                  fontSize: 26,
                  lineHeight: 30,
                  textAlign: 'center',
                }}
                text={'Continue Hunt >'}
              />
            </View>
          )}
          <BodyText
            textStyle={{
              color: global?.color?.white,
              fontSize: 14,
              marginBottom: 5,
            }}
            text={
              warning
                ? `Warning: You already started a ${
                    currentHuntInfo?.huntCity
                  } Scavenger Hunt recently on ${
                    currentHuntInfo?.dateEventLastJoined || 'unkown'
                  }! To continue this hunt please tap here >>`
                : `Continue Your ${
                    currentHuntInfo?.huntCity || ''
                  } Scavenger Hunt: Started on ${
                    currentHuntInfo?.dateEventLastJoined || 'unkown'
                  } !!`
            }
          />
        </View>
      </TouchableOpacity>
    </View>
  );
};
export default ContinueHuntCard;
